// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__309YC","SchoolLogo":"Logo_SchoolLogo__dhvr4"};